import { sendPushSubcription } from 'actions/push'
import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'
import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import { pushActions } from 'features/Messaging/messaging-helpers'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router'
import { pushPublicKey } from 'services/config'
import { urlB64ToUint8Array } from 'utils/helpers'

import bell from './bell.png'
import styles from './EnableNotificationsBox.module.scss'
// import notificationAllowImg from './NotificationAllow.png'
// import step1 from './NotificationTutorialStep1.png'
// import step2 from './NotificationTutorialStep2.png'

const EnabledNotificationsBox = ({
  permission: defaultPermission,
  setNotificationPermission
}) => {
  const [permission, setPermission] = useState(defaultPermission)

  const history = useHistory()

  function askNotificationPermission() {
    Notification.requestPermission().then(res => {
      setPermission(res)
      setNotificationPermission(res)
    })
  }

  const dispatch = useDispatch()

  function handleServiceWorkerMessage(event) {
    const { action } = event.data

    if (action === pushActions.NavigateTo) {
      history.push(event.data.path)
    }
  }

  async function sendPushSubscriptionToServiceWorker() {
    if ('serviceWorker' in navigator && 'PushManager' in window && window.Notification) {
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage)

      const serviceWorker = await navigator.serviceWorker.ready

      if (Notification.permission === 'granted') {
        const subscription = await serviceWorker.pushManager.getSubscription()

        if (subscription) {
          dispatch(sendPushSubcription(subscription.toJSON()))
        } else {
          const subscription = await serviceWorker.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array(pushPublicKey)
          })
          dispatch(sendPushSubcription(subscription.toJSON()))
        }
      }
    }
  }

  if (permission === 'granted') {
    sendPushSubscriptionToServiceWorker()
    return null
  }

  return (
    <ConfirmationDialog
      title=""
      positiveMessage="Enable notifications"
      hasConfirmButton={false}
      onConfirm={askNotificationPermission}
      onClose={() => history.push('/')}
    >
      <div className={styles.bellWrapper}>
        <div className={styles.bellIconContainer}>
          <img src={bell} alt="bell" className={styles.bellIcon} />
        </div>
        <p className={styles.bellDialogTitle}>Enable notifications to use messaging</p>
        <p className={styles.bellDialogText}>
          Messaging on the Dashboard works with desktop notifications.{' '}
        </p>
        <p className={styles.bellDialogText}>
          Click on Enable notifications and when being asked,{' '}
          <strong>click allow.</strong>
        </p>
        <div className={styles.bellCtaHolder}>
          <PrimaryRegularButton
            className={styles.bellCta}
            onClick={askNotificationPermission}
          >
            Enable notifications
          </PrimaryRegularButton>
        </div>
      </div>
    </ConfirmationDialog>
  )
}

// const AllowNotificationImg = () => (
//   <img alt="Showing how to enable notification" src={notificationAllowImg} />
// )

// const EnableNotificationTutorial = () => (
//   <div className={styles.tutorial}>
//     <img
//       src={step1}
//       className={styles.tutorialStep1}
//       alt="Showing how to enable notification"
//     />
//     <img
//       src={step2}
//       className={styles.tutorialStep2}
//       alt="Showing how to enable notification"
//     />
//   </div>
// )

// const Instructions = ({ permission }) => (
//   <>
//     {permission === 'default' ? (
//       <p>Messaging requires notifications to be enabled. Click on allow to enable.</p>
//     ) : (
//       <div className={styles.list}>
//         <p>
//           <span className={styles.number}>1.</span>Click on the lock icon on address bar
//         </p>
//         <p>
//           <span className={styles.number}>2.</span>Select Allow from notifications box
//         </p>
//       </div>
//     )}
//   </>
// )

export default EnabledNotificationsBox
